module.exports = __webpack_public_path__ + "media/images/logo-white-43148c29c00ede4ca25574d3ed95ee31.svg";